import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';

import PropTypes from 'prop-types';
import qs from 'querystring';
import { format, parseISO } from 'date-fns';
import { isArray, isEmpty } from 'lodash';

import api from '~/services/api';
import { t } from '~/helpers';
import { Table } from '~/components';

import * as S from './styles';

export default function Details({ data }) {
  const [logs, setLogs] = useState([]);

  const header = useMemo(
    () => [
      {
        id: 'ltev_datahora',
        label: 'Data Evento',
        format: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm:ss'),
      },
      { id: 'ltev_cod_log', label: 'Cod Log' },
      { id: 'ltev_num_log', label: 'Num Log' },
      { id: 'ltev_descricao', label: 'Descrição' },
      { id: 'tempo', label: 'Tempo' },
    ],
    []
  );

  const handleGetAPIDetails = useCallback(async () => {
    try {
      const {
        abas_datahora_ini,
        abas_datahora_fim,
        post_cod_posto,
        bico_cod_bico,
      } = data;

      const wherefield = [
        'datahorainicial',
        'datahorafinal',
        'post_cod_posto',
        'bico_cod_bico',
      ];
      const valuewherefield = [
        format(parseISO(abas_datahora_ini), 'dd/MM/yyyy HH:mm:ss'),
        format(parseISO(abas_datahora_fim), 'dd/MM/yyyy HH:mm:ss'),
        post_cod_posto,
        bico_cod_bico,
      ];
      const typewherefield = ['MAIOR_IGUAL', 'MENOR_IGUAL', 'EQUALS', 'EQUALS'];

      const response = await api.get('logtcaeventos', {
        params: {
          wherefield,
          valuewherefield,
          typewherefield,
          pagesize: 999999,
        },
        paramsSerializer: (param) => qs.stringify(param),
      });

      setLogs(response.data.items);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [data]);

  useEffect(() => {
    handleGetAPIDetails();
  }, [data]);

  if (!isEmpty(data) && data.abas_datahora_ini)
    return (
      <S.Wrapper>
        <S.Header>Dados do Abastecimento A2VF</S.Header>
        <S.HeaderWrapper>
          <li>
            <span>Data:</span>{' '}
            {format(parseISO(data.abas_datahora_ini), 'dd/MM/yyyy HH:mm:ss')}
          </li>
          <li>
            <span>DLOC #Série:</span> {data.abas_numero_serie_dloc}
          </li>
          <li>
            <span>Posto:</span> {data.post_desc}
          </li>
          <li>
            <span>DLOC Ver.FW:</span> {data.abas_versao_firmware_dloc}
          </li>
          <li>
            <span>Locomotiva:</span> {data.veic_cod_veic}
          </li>
          <li>
            <span>DLOC Compilação Data:</span> {data.abas_data_compilacao_dloc}
          </li>
          <li>
            <span>Bico:</span> {data.bico_cod_bico}
          </li>
          <li>
            <span>DLOC Compilação Hora:</span> {data.abas_hora_compilacao_dloc}
          </li>
          <li>
            <span>Volume:</span> {data.abas_volume}
          </li>
          <li>
            <span>Overfill Atuou:</span> {data.abas_overfillatuou_str}
          </li>
          <li>
            <span>Identificação DLOC:</span> {data.abas_dloc_atuado_status_str}
          </li>
          <li>
            <span>Status Overfill Final:</span>{' '}
            {data.abas_overfillatlersennivdloc_str}
          </li>
          <li>
            <span>Identificação DBIC:</span> {data.abas_dbic_atuado_status_str}
          </li>
          <li>
            <span>Liberação Utilizando Overfill:</span>{' '}
            {data.abas_liberado_com_overfill_str}
          </li>
          <li>
            <span>Liberação utilizando Homem Morto:</span>{' '}
            {data.abas_liberado_com_homem_morto_str}
          </li>
        </S.HeaderWrapper>

        <S.Header>Logs de Evento do TCA</S.Header>

        <Table cells={header} data={logs} size="small" />
      </S.Wrapper>
    );

  return <div />;
}
Details.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};
